import "./FooterItem.css";
import { Link, useLocation } from "react-router";

function FooterItem() {
  const { pathname } = useLocation();

  const textColorStyle = {
    color:
      (pathname === "/privacy" || pathname === "/terms") &&
      "rgba(10, 10, 10, 1)",
  };

  return (
    <footer
      className="footer"
      style={{
        backgroundColor:
          (pathname === "/privacy" || pathname === "/terms") && "transparent",
      }}
    >
      <div>
        <p className="footerText" style={textColorStyle}>
          © FIRSTPEEL INC. 2026
        </p>
        <p className="footerText" style={textColorStyle}>
          contact@firstpeel.com
        </p>
        <a
          href="/licenses.html"
          rel="nofollow"
          className="footerText"
          style={textColorStyle}
        >
          Third-Party Licenses
        </a>
      </div>
      <div>
        <Link to="/" className="footerText" style={textColorStyle}>
          Home
        </Link>
        <Link to="/terms" className="footerText" style={textColorStyle}>
          Terms
        </Link>
        <Link to="/privacy" className="footerText" style={textColorStyle}>
          Privacy Policy
        </Link>
      </div>
    </footer>
  );
}

export default FooterItem;
